<template>
  <b-modal
      v-model="visible"
      title="گزارش سگمنت"
      cancel-variant="outline-secondary"
      centered
      hide-footer
      :no-close-on-backdrop="true"
      size="xl"
  >
    <b-overlay
        :show="loading"
        rounded="sm"
    >
      <div class="d-flex align-items-center mb-2">
        <div style="width:150px" class="d-flex align-items-center mr-2">
          <p style="margin: 0" class="mr-1">از</p>
          <date-picker v-model="fromDate" />
        </div>
        <div style="width:150px" class="d-flex align-items-center mr-1">
          <p style="margin: 0" class="mr-1">تا</p>
          <date-picker v-model="toDate" :min="fromDate" />
        </div>
        <div class="mr-1">
          <segment-select v-model="compareSegments" style="width: 350px" placeholder="سگمنت" :limit="3" />
        </div>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            class="btn-icon"
            @click="update"
        >
          <feather-icon
              icon="RefreshCcwIcon"
              size="16"
          />
        </b-button>
      </div>
      <div style="min-height: 415px;">
        <vue-apex-charts v-if="series.length" type="line" height="400" :options="chartOptions" :series="series" />
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import SegmentSelect from "@/tools/segmentSelect.vue";
export default {
  name: "segmentReportItem",
  props: {
    show: { type: Boolean, default: false },
    data: { type: Object, default: null },
  },
  components: { VueApexCharts, SegmentSelect },
  data() {
    return {
      loading: false,
      report: [],
      fromDate: null,
      toDate: null,
      compareSegments: [],
      segments: [],
      chartOptions: {
        chart: {
          type: 'line',
          fontFamily: 'IranSans',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2,
          curve: 'straight',
          dashArray: [0, 0, 0]
        },
        markers: {
          size: 3,
          hover: {
            sizeOffset: 3
          }
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          followCursor: true,
          x: {
            show: false
          },
        },
        colors: ['#6fb04d','#8ecae6', '#FD6A6A', '#775DD0', '#78c6a3', '#004e98'],
        grid: {
          borderColor: '#f1f1f1',
        }
      },
      series: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val) {
          console.log('watch')
          this.compareSegments = [this.data.id]
          this.update()
        }
      }
    }
  },
  created() {
    this.fromDate = this.$moment().startOf('jMonth').format('YYYY/MM/DD')
    this.toDate = this.$moment().endOf('jMonth').format('YYYY/MM/DD')
  },
  methods: {
    async update() {
      this.report = []
      for (let i = 0; i < this.compareSegments.length; i++) {
        await this.getData(this.compareSegments[i])
      }
      this.loading = false
      this.series = this.report
      this.chartOptions.xaxis.categories = this.series.length && this.series[0].date.map(item => this.$moment(item.CreateAt).format('jM/jD'))
    },
    getData(item) {
      console.log(item)
      this.loading = true
      let data = {
        Id: item,
        IsBaseSegment: this.data.isBaseSegment,
        FromDate: this.fromDate,
        ToDate: this.toDate
      }

      return this.$http.post(
          this.$api.segmentReports.get, data,
      )
          .then(response => {
            let data = {
              name: response.data.length && response.data[0].Title,
              data: response.data.map(item => item.Count),
              date: response.data.map(item => item.CreateAt)
            }
            this.report.push(data)
          }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style>
.apexcharts-legend-text {
  margin-left: 5px !important;
}
</style>